<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
            
            <el-tab-pane label="护理" name="first">
                <el-table :data="totalGuestInfo" style="width: 100%" size="mini" class="mytable" v-loading="querybutton">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.data" border style="width: 100%;" :show-header="false" :row-class-name="tableRowClassName">
                                <el-table-column prop="date">
                                  <template slot-scope="scope">
                                    <el-form>
                                      <el-row>
                                        <el-col :span="8">
                                          <el-form-item label="会员姓名:">
                                            <span>{{scope.row.membername}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="卡号:">
                                            <span>{{scope.row.cardnumber}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="护理间隔:">
                                            <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                      <el-row>
                                        <el-col :span="24">
                                          <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                          <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                          <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                          <el-button size="mini" @click="openStaff(scope)">{{scope.row.staffname}}</el-button>
                                          <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                        </el-col>
                                      </el-row>
                                    </el-form>
                                  </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column label="名称" prop="label"></el-table-column>
                    <el-table-column label="人数" prop="number"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="头皮" name="second">
                <el-table :data="totalTpGuestInfo" style="width: 100%" class="mytable" v-loading="querybutton">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.data" border style="width: 100%;" :show-header="false" :row-class-name="tableRowClassName">
                                <el-table-column prop="date">
                                  <template slot-scope="scope">
                                    <el-form>
                                      <el-row>
                                        <el-col :span="8">
                                          <el-form-item label="会员姓名:">
                                            <span>{{scope.row.membername}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="卡号:">
                                            <span>{{scope.row.cardnumber}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="护理间隔:">
                                            <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                      <el-row>
                                        <el-col :span="24">
                                          <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                          <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                          <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                          <el-button size="mini" @click="openStaff(scope)">{{scope.row.staffname}}</el-button>
                                          <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                        </el-col>
                                      </el-row>
                                    </el-form>
                                  </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column label="名称" prop="label"></el-table-column>
                    <el-table-column label="人数" prop="number"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="全部" name="third">
                <el-table :data="totalStoreAllGuestInfo" style="width: 100%" size="mini" class="mytable" v-loading="querybutton">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.data" border style="width: 100%;" :show-header="false" :row-class-name="tableRowClassName">
                                <el-table-column prop="date">
                                  <template slot-scope="scope">
                                    <el-form>
                                      <el-row>
                                        <el-col :span="8">
                                          <el-form-item label="会员姓名:">
                                            <span>{{scope.row.membername}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="卡号:">
                                            <span>{{scope.row.cardnumber}}</span>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                          <el-form-item label="护理间隔:">
                                            <span>{{scope.row.hldays}}({{scope.row.days}})</span>
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                      <el-row>
                                        <el-col :span="24">
                                          <el-button size="mini" @click="openCardTranHistory(scope.row)">消费记录</el-button>
                                          <el-button size="mini" @click="openCardFiles(scope.row)">顾客档案</el-button>
                                          <el-button size="mini" @click="openCourse(scope.row.cardid)">疗程</el-button>
                                          <el-button size="mini" @click="openStaff(scope)">{{scope.row.staffname}}</el-button>
                                          <span style="color: #409EFF" v-if="scope.row.courseid=='1'">已预约</span>
                                        </el-col>
                                      </el-row>
                                    </el-form>
                                  </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column label="名称" prop="label"></el-table-column>
                    <el-table-column label="人数" prop="number"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="负责人"
              show-toolbar
              :columns="hairStaff"
              value-key="staffname"
              :defaultIndex="defaultIndex"
              @confirm="onConfirm"
              @cancel="this.show=false"
            />
        </van-popup>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                querybutton:false,
                show:false,
                defaultIndex:0,
                storeid:localStorage.getItem("storeid"),
                activeName:"first",
                totalGuestInfo:[],
                totalTpGuestInfo:[],
                totalStoreAllGuestInfo:[],
                hairStaff:[],
                beautyStaff:[],
                curCardId:"",
                curData:{},
                curIndex:0,
            }
        },
        created: function () {
            this.getStoreHeadStaffCardInfo(1);
            this.getStaffByJob();
        },
        methods:{
            onConfirm(e) {
                let headstaff = new Object();
                headstaff.storeid = e.storeid;
                headstaff.staffid = e.staffid;
                headstaff.cardid = this.curCardId;
                headstaff.createtor = localStorage.getItem("staffid");
                headstaff.type = 2;
                let headstaffs = [];
                headstaffs.push(headstaff);
                this.$postw("cardinfo/saveHeaderStaff?storeid=" + e.storeid + "&staffid=" + e.staffid, headstaffs).then(res => {
                    if (res.sucess) {
                        this.$message.success("设置成功");
                        this.curData.staffid=headstaff.staffid;
                        this.curData.staffname=e.staffname;
                        if(this.activeName=="first"){
                            this.totalGuestInfo[this.curIndex]=this.curData;
                        }
                        else if(this.activeName=="second"){
                            this.totalTpGuestInfo[this.curIndex]=this.curData;
                        }
                        else if(this.activeName==""){
                            this.totalStoreAllGuestInfo[this.curIndex]=this.curData;
                        }
                        this.show=false;
                        //this.getHeadStaffCardInfo();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            getStaffByJob(){
                this.$post("staff/getStaffByJob",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                    let obj=res.object;
                    this.beautyStaff=[];
                    this.hairStaff=[];
                    if(obj!=null && obj.length>0){
                        for(let val of obj){
                        if(val.deptid=="31"){
                            if(val.posid=="ca5f888b2acc46b98d6d2f265ae5101a" || val.posid=="f1f91003a7464557af536065a06df68e" || val.posid=="4aebd0e8576b459c9f3eec52f1e21d1e"
                            || val.posid=="42d7c57fc37e4b2c83b89babb6d33487" || val.posid=="9d6032cc834748f5bc2932ff73bd9d57"){
                            this.hairStaff.push(val);
                            }
                        }
                        else if(val.deptid=="32"){
                            if(val.posid!="71ea514634c44d42815b83092f32dbe8" && val.posid!="e93cc384696744be8d1bc814dfe520ac" && val.posid!="b3754d808b204146b16f2fef6c80da30"){
                                this.beautyStaff.push(val);
                            }
                        }
                        }
                    }
                    }
                    else{
                    this.$message.error(res.message);
                    }
                });
            },
            openStaff(item){
                this.show=true;
                this.defaultIndex=0;
                this.curCardId=item.row.cardid;
                this.curData=item.row;
                this.curIndex=item.$index;
                for(let index in this.hairStaff){
                    if(item.row.staffid==this.hairStaff[index].staffid){
                        this.defaultIndex=index;
                        break;
                    }
                }
            },
            openCourse(cardid){
                this.$router.push({
                    path:"/cardcourse",
                    query:{
                    cardid:cardid
                    }
                });
            },
            openCardFiles(item){
                this.$router.push({
                    path:"/haircustfiles",
                    query:{
                    cardid:item.cardid
                    }
                });
            },
            openCardTranHistory(item){
                this.$router.push({
                    path:"/cardtranhistory",
                    query:{
                    cardid:item.cardid
                    }
                });
            },
            handleClick(e,event){
                if("second"==e.name){
                    if(this.totalTpGuestInfo.length<1){
                        this.getStoreHeadStaffCardInfo(2);
                    }
                }
                else if("third"==e.name){
                    if(this.totalStoreAllGuestInfo.length<1){
                        this.getStoreHeadStaffCardInfo(3);
                    }
                }
            },
            tableRowClassNametp(row, rowIndex){
                if(row.row.hldays<15){
                    return 'blue';
                }
                else if(row.row.hldays<25){
                    return 'orange'
                }
                else if(row.row.hldays>=25){
                    return 'red'
                }
                return '';
            },
            tableRowClassName(row, rowIndex){
                if(row.row.hldays<10){
                    return 'blue';
                }
                else if(row.row.hldays<20){
                    return 'orange'
                }
                else if(row.row.hldays>=20){
                    return 'red'
                }
                return '';
            },
            getCardTotalGuestInfo(){
                this.$post("cashreport/getCardTotalGuestInfo",{storeid:this.storeid,fromdate:this.jxfromdate,todate:this.jxtodate,days:90,projectType:3,type:2}).then(res=>{
                    if(res.sucess){
                        this.jxDatas=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getStoreHeadStaffCardInfo(type){
                this.querybutton=true;
                this.$post("ddstaff/getHeadStaffByHlCardInfo",{storeid:this.storeid,staffid:null,type:type}).then(res=>{
                    this.querybutton=false;
                    if(res.sucess){
                        if(type==1) {
                            let obj=res.object;
                            let hldata=new Object();
                            hldata.label="活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>0 && val.hldays<=10){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="需要关注客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>10 && val.hldays<=20){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="不活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>20 && val.hldays<=30){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="死亡客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>30){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalGuestInfo.push(hldata);

                            console.log(this.totalGuestInfo)

                        }
                        else if(type==2){

                            let obj=res.object;
                            let hldata=new Object();
                            hldata.label="活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>0 && val.hldays<=15){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalTpGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="需要关注客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>15 && val.hldays<=25){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalTpGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="不活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>25 && val.hldays<=35){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalTpGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="死亡客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>35){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalTpGuestInfo.push(hldata);

                            //this.totalTpGuestInfo=res.object;
                        }
                        else if(type==3){
                            let obj=res.object;
                            let hldata=new Object();
                            hldata.label="活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>0 && val.hldays<=10){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalStoreAllGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="需要关注客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>10 && val.hldays<=20){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalStoreAllGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="不活跃客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>20 && val.hldays<=30){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalStoreAllGuestInfo.push(hldata);
                            hldata=new Object();
                            hldata.label="死亡客";
                            hldata.number=0;
                            hldata.data=[];
                            for(let val of obj){
                                if(val.hldays>30){
                                    hldata.data.push(val);
                                    hldata.number++;
                                }
                            }
                            this.totalStoreAllGuestInfo.push(hldata);
                            //this.totalStoreAllGuestInfo=res.object;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">

    .el-table .el-form-item{
        margin-bottom: 0;
    }

    .el-table .el-form-item__label{
        padding: 0px;
    }

    .el-table tr {
        .el-table__expanded-cell {
        // 样式覆盖
        padding: 0px;
    }

  .el-table .blue {
    background: #dbf6cb;
  }

  .el-table .orange {
    background: #fcebcd;
  }

  .el-table .red {
    background: #fcb3b3;
  }

}

</style>



// WEBPACK FOOTER //
// src/page/manager/hairhl.vue